import React, {useEffect, useState} from 'react';
import Popup from "./popup";
import axios from 'axios';

export default function BackupAccountTermsPopup({closeHandler}){

    return (
        <Popup closeHandler={closeHandler} >
            <div className={'popup-content thrive-description'} >
                <h2><img src={'/images/thrive-contribution.svg'} alt={''} />Add an Alternate Checking Account for Student Loan Payments</h2>
                <div className={'terms-container'}>
                    <h3>
                        We're introducing an optional feature that allows you to add a personal checking account as a backup payment method within the student loan repayment platform.
                        This alternate account will only be used temporarily if we’re unable to send payments directly to your loan servicer. This may occur due to technical issues, connection errors, or updates on the service provider’s platform.
                        Here’s how it works:
                    </h3>
                    <ul>
                        <li>
                            If a direct payment to your student loan servicer is unsuccessful or cannot be attempted, we will deposit your scheduled payment into your designated alternate checking account.
                        </li>
                        <li>
                            You’ll receive a notification when this happens.
                        </li>
                        <li>
                            You are responsible for using those funds to make your student loan payment directly to your loan servicer.
                        </li>
                    </ul>
                    <h3>
                        By adding an alternate account, you acknowledge and agree that:
                    </h3>
                    <ul>
                        <li>
                            Payments made to this account are intended solely for your student loan obligations.
                        </li>
                        <li>
                            You are responsible for making your loan payment during any period when payments are routed to your alternate account instead of directly to your loan servicer.
                        </li>
                    </ul>
                    <p>
                        This feature is designed to prevent missed payments and support your continued progress toward loan repayment, even during temporary disruptions.
                    </p>
                </div>
            </div>
        </Popup>
    )
}
